import { render, staticRenderFns } from "./MSODiscountRules.vue?vue&type=template&id=4eb22222&"
import script from "./MSODiscountRules.vue?vue&type=script&lang=js&"
export * from "./MSODiscountRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports